// Keys used for redirect
export const LS_ROUTE_KEY = 'ROUTE_KEY'
export const LS_ROUTE_PARAMS = 'ROUTE_PARAMS'
export const LS_ROUTE_QUERY = 'ROUTE_QUERY'
export const LS_ROUTE_EXPIRED_SESSION = 'ROUTE_EXPIRED_SESSION'

export const LAST_USER = 'LAST_USER'
